import React from 'react';
import { Badge } from './ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Shield, Database, Target, Wrench, Award, BookOpen } from 'lucide-react';

const BASkills = () => {
  const skillGroups = [
    {
      icon: Shield,
      title: 'IAM & Security',
      color: 'border-2 border-blue-200 bg-white',
      skills: ['Azure Active Directory', 'Saviynt', 'LDAP', 'SSO', 'RBAC', 'Entitlement Validation'],
    },
    {
      icon: Database,
      title: 'Data & BI',
      color: 'border-2 border-teal-200 bg-white',
      skills: ['Snowflake', 'SQL', 'Power BI', 'DAX', 'REST APIs', 'Python (Pandas)'],
    },
    {
      icon: Target,
      title: 'BA & Delivery',
      color: 'border-2 border-cyan-200 bg-white',
      skills: ['User Stories', 'Acceptance Criteria', 'UAT', 'Gap Analysis', 'Agile / Scrum', 'Backlog Grooming'],
    },
    {
      icon: Wrench,
      title: 'Tools',
      color: 'border-2 border-indigo-200 bg-white',
      skills: ['Jira', 'Confluence', 'SQL Server', 'Microsoft Fabric', 'Power Query', 'Visio'],
    },
    {
      icon: Award,
      title: 'Certifications',
      color: 'border-2 border-green-200 bg-white',
      skills: ['CSPO — Certified Scrum Product Owner', 'MS in IT Management (GPA 3.90)', 'Okta Certified Professional (in progress)'],
    },
    {
      icon: BookOpen,
      title: 'Currently Learning',
      color: 'border-2 border-slate-200 bg-white',
      skills: ['Okta Platform', 'Zero Trust Architecture', 'AI-native IAM', 'Non-human Identity'],
    },
  ];

  return (
    <section id="skills" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="mb-16">
            <Badge className="mb-4 bg-blue-100 text-blue-800 border-blue-200 font-semibold">Expertise</Badge>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Skills & Certifications
            </h2>
            <p className="text-lg text-slate-600 max-w-3xl">
              Comprehensive technical and delivery capabilities across IAM, data platforms, and business analysis.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {skillGroups.map((group, index) => {
              const Icon = group.icon;
              return (
                <Card key={index} className={`${group.color} hover:shadow-lg transition-all duration-300`}>
                  <CardHeader>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-slate-100 border-2 border-slate-300 rounded-lg flex items-center justify-center">
                        <Icon className="text-slate-700" size={20} />
                      </div>
                      <CardTitle className="text-lg font-bold text-slate-900">{group.title}</CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="flex flex-wrap gap-2">
                      {group.skills.map((skill, idx) => (
                        <Badge
                          key={idx}
                          variant="secondary"
                          className="bg-slate-100 hover:bg-slate-200 text-slate-700 border border-slate-300 text-xs font-medium"
                        >
                          {skill}
                        </Badge>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BASkills;